import React, { useEffect, useState } from 'react';
import styles from '../../../styles/adminEvents.module.css';
import ConfirmModal from '../../../shared/components/ConfirmModal';
import { Navigate } from "react-router-dom";
import { requesturl } from '../../../shared/utils/requesturl';

const EVENTS_API = `${requesturl}events.php`;
export default function AdminEvents() {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const [form, setForm] = useState({ title: '', startDate: '', startTime: '', endDate: '', endTime: '', color: '#3b82f6' });
  const [submitting, setSubmitting] = useState(false);
  const [message, setMessage] = useState('');
  const [messageType, setMessageType] = useState('');
  function fetchEvents() {
    setLoading(true);
    fetch(EVENTS_API)
      .then((r) => r.json())
      .then((data) => {
        setEvents(Array.isArray(data) ? data : []);
        setLoading(false);
      })
      .catch((e) => { setError('Failed to load events'); setLoading(false); console.error(e); });
  }

  useEffect(() => { fetchEvents(); }, []);

  function handleChange(e) {
    const { name, value } = e.target;
    setForm((f) => ({ ...f, [name]: value }));
    // clear messages on change
    setMessage('');
    setMessageType('');
  }

  function buildDateTime(date, time) {
    if (!date) return '';
    return time ? `${date}T${time}` : date;
  }

  function isValidDateString(s) {
    if (!s) return false;
    const t = Date.parse(s);
    return !Number.isNaN(t);
  }

  function handleSubmit(e) {
    e.preventDefault();
    // client-side validation
    if (!form.title.trim()) {
      setMessage('Title is required'); setMessageType('error'); return;
    }
    if (!form.startDate) {
      setMessage('Start date is required'); setMessageType('error'); return;
    }
    const start = buildDateTime(form.startDate, form.startTime);
    const end = buildDateTime(form.endDate, form.endTime);
    if (!isValidDateString(start)) {
      setMessage('Start date/time is invalid'); setMessageType('error'); return;
    }
    if (end && !isValidDateString(end)) {
      setMessage('End date/time is invalid'); setMessageType('error'); return;
    }
    if (end && Date.parse(end) < Date.parse(start)) {
      setMessage('End must be the same or after Start'); setMessageType('error'); return;
    }
    setSubmitting(true);
    const payload = { action: 'add', title: form.title, start, end, color: form.color };
    fetch(EVENTS_API, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    })
      .then((r) => r.text())
      .then((data) => {
        // if API returns the created event, append it; else just refetch
        if (data && data.id) setEvents((evs) => [...evs, data]);
        else fetchEvents();
        setForm({ title: '', startDate: '', startTime: '', endDate: '', endTime: '', color: '#3b82f6' });
        setMessage('Event added'); setMessageType('success');
      })
      .catch(() => setError('Failed to add event'))
      .finally(() => setSubmitting(false));
  }
  // pending deletion id for modal confirm
  const [pendingDelete, setPendingDelete] = useState(null);

  function handleDelete(id) {
    fetch(EVENTS_API, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ action: 'delete', id }),
    })
      .then((r) => r.text())
      .then((data) => {
        if (data && data.success) setEvents((evs) => evs.filter((e) => e.id !== id));
        else fetchEvents();
        setMessage('Event deleted'); setMessageType('success');
        console.log(data);
      })
      .catch((e) => setError('Failed to delete'));
  }

  function confirmDelete() {
    if (!pendingDelete) return;
    handleDelete(pendingDelete);
    setPendingDelete(null);
  }

  function cancelDelete() {
    setPendingDelete(null);
  }

 if( sessionStorage.getItem('isAdmin') === 'true'){ 
   return (
  <div className={styles.wrapper}>
      <h3 className={styles.title}>Admin: Manage Events</h3>

      <form onSubmit={handleSubmit} className={styles.form}>
        <label className={styles.fullWidth}>Title
          <input name="title" type='text' value={form.title} onChange={handleChange} required />
        </label>
        <label>Start Date *
          <input name="startDate" type="date" value={form.startDate} onChange={handleChange} required />
        </label>
        <label>Start Time (optional)
          <input name="startTime" type="time" value={form.startTime} onChange={handleChange} />
        </label>
        <label>End Date (optional)
          <input name="endDate" type="date" value={form.endDate} onChange={handleChange} />
        </label>
        <label>End Time (optional)
          <input name="endTime" type="time" value={form.endTime} onChange={handleChange} />
        </label>
        <label className={styles.colorLabel}>Color
          <input name="color" value={form.color} onChange={handleChange} type="color" />
        </label>
        <button type="submit" className={styles.submit} disabled={submitting}>{submitting ? 'Adding...' : 'Add Event'}</button>
      </form>

      {message && (
        <div className={`${styles.message} ${messageType === 'error' ? styles.messageError : styles.messageSuccess}`} role="status">
          {message}
        </div>
      )}

      <div className={styles.list}>
        <h4>Existing events</h4>
        {loading && <div>Loading...</div>}
        {error && <div className={styles.error}>{error}</div>}
        {!loading && events.length === 0 && <div>No events</div>}
        <ul>
          {[...events].reverse().map((ev) => (
            <li key={ev.id} className={styles.eventItem}>
              <div className={styles.meta}>
                <div className={styles.evTitle} style={{ color: ev.color || '#111' }}>{ev.title}</div>
                <div className={styles.evRange}>{ev.start} → {ev.end}</div>
              </div>
              <div>
                <button className={styles.delete} onClick={() => setPendingDelete(ev.id)}>Delete</button>
              </div>
            </li>
          ))}
        </ul>
      </div>
      <ConfirmModal
        isOpen={Boolean(pendingDelete)}
        title="Delete event"
        message="Are you sure you want to delete this event? This cannot be undone."
        onConfirm={confirmDelete}
        onCancel={cancelDelete}
      />
    </div>
   )

  }

  return <Navigate to="/admin" replace />;


}
